import AppPageText from "./AppPageText";

import "./AppPageText.scss";

export { AppPageText };
